<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Avaliação Oficinas Reuniões Treinamentos"
            description="Avaliação e sugestões de temas em saúde digital"
            url="/oficinas-treinamentos"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Avaliação Treinamentos',
    titleTemplate: null,
  },
}
</script>
